define([
    "../../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.service("carrierDrawingCommonService", [
        "hereMapsService",
        function (hereMapsService) {
            var DRAG_LIMIT_IN_PX = 6;

            return {
                getPixelDistance: getPixelDistance,
                isValidTap: isValidTap,
                isValidDrag: isValidDrag,
                setCursor: setCursor,
                createClosedPolygon: createClosedPolygon
            };

            function getPixelDistance(pointA, pointB) {
                var dx = pointA.x - pointB.x;
                var dy = pointA.y - pointB.y;
                return Math.sqrt(dx * dx + dy * dy);
            }

            function isValidTap(distanceInPx) {
                return distanceInPx < DRAG_LIMIT_IN_PX;
            }

            function isValidDrag(distanceInPx) {
                return distanceInPx > DRAG_LIMIT_IN_PX;
            }

            function setCursor(isDrawing) {
                var element = hereMapsService.getMap().getViewPort().element;
                if (isDrawing) {
                    element.classList.add("drawing-mode");
                } else {
                    element.classList.remove("drawing-mode");
                }
            }

            function createClosedPolygon(points) {
                if (!points || points.length === 0) {
                    return [];
                }

                var polygonPoints = points.map(function (point) {
                    return {
                        lat: point.lat,
                        lng: point.lng
                    };
                });

                polygonPoints.push({
                    lat: points[0].lat,
                    lng: points[0].lng
                });

                return {
                    points: polygonPoints,
                    editable: true
                };
            }
        }
    ]);
});